<p-select
  [options]="options"
  [(ngModel)]="value"
  [placeholder]="placeholder | translate"
  [showClear]="showClear"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [disabled]="isDisabled"
  [styleClass]="styleClass"
  [appendTo]="appendTo"
  (onChange)="onDropdownChange($event)">
  <ng-template
    pTemplate="selectedItem"
    let-item>
    <span *ngIf="item">{{ item[optionLabel] | translate }}</span>
  </ng-template>

  <ng-template
    pTemplate="item"
    let-item>
    <span>{{ item[optionLabel] | translate }}</span>
  </ng-template>
</p-select>
